"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousQuestion = void 0;
function getPreviousQuestion(db, q, count = 1, ignoreKids = false) {
    const idx = q.parentListIdx;
    const listId = q.parentListId;
    const list = db.lists[listId];
    const listQIds = list.childQIds;
    const parentQId = list.parentQId;
    // Up by a number
    if (count > 1) {
        const nextIdx = idx - count < 0 ? 0 : idx - count;
        return db.questions[listQIds[nextIdx]];
    }
    // Up to previous sibling question
    if (idx > 0) {
        const nextIdx = idx - count < 0 ? 0 : idx - count;
        return ignoreKids
            ? db.questions[listQIds[nextIdx]]
            : getDeepestExpandedQuestion(db, db.questions[listQIds[nextIdx]]);
    }
    // Up to previous sibling list
    if (list.idx > 0) {
        const parentQ = db.questions[parentQId];
        const siblingListQIds = db.lists[parentQ.childListIds[list.idx - 1]].childQIds;
        const lastSiblingQ = db.questions[siblingListQIds[siblingListQIds.length - 1]];
        return ignoreKids ? lastSiblingQ : getDeepestExpandedQuestion(db, lastSiblingQ);
    }
    // Up to parent
    if (parentQId)
        return db.questions[parentQId];
    // Can't move up
    return q;
}
exports.getPreviousQuestion = getPreviousQuestion;
exports.default = getPreviousQuestion;
function getDeepestExpandedQuestion(db, q) {
    var _a;
    if (!(q === null || q === void 0 ? void 0 : q.expanded) || !((_a = q === null || q === void 0 ? void 0 : q.childListIds) === null || _a === void 0 ? void 0 : _a.length))
        return q;
    const childListIds = q === null || q === void 0 ? void 0 : q.childListIds;
    const lastChildListId = childListIds[childListIds.length - 1];
    const lastChildList = db.lists[lastChildListId];
    const lastQIds = lastChildList.childQIds;
    const lastQId = lastQIds[lastQIds.length - 1];
    return getDeepestExpandedQuestion(db, db.questions[lastQId]);
}
